import {
  Stack,
  Text,
  Heading,
  Divider,
  Card,
  Columns,
  List,
  Box,
  Column,
} from 'braid-design-system';
import queryString from 'query-string';
import React from 'react';

import Routes from 'src/config/routes';

import BulletLink from './components/BulletLink/BulletLink';
import Tool from './components/Tool/Tool';
import AdWritingSvg from './resources/AdWriting.svg';
import CalculatorSvg from './resources/Calculator.svg';
import ChecklistSvg from './resources/Checklist.svg';
import ScreeningSvg from './resources/Screening.svg';

const adWritingGuideVideoLink = 'https://www.youtube.com/embed/VbF-wceZbqY';

const ToolsTab = () => (
  <Stack space="large">
    <Heading level="2">Tools to help you sell</Heading>
    <Text>
      Every business is unique and selling a business can be a daunting process.
      The tools and articles below are designed to help simplify things and
      provide a little guidance along the way.
    </Text>
    <Card>
      <Columns space={['xlarge', 'medium']} collapseBelow="desktop">
        <Column>
          <Tool
            enabled={true}
            svg={AdWritingSvg}
            label="Ad Writing Tips"
            destination={queryString.stringifyUrl({
              url: Routes.ASSET,
              query: { key: Routes.AD_WRITING_TIPS },
            })}
            description="An ad writing guide to help your business be found, gain attention and be desirable to prospective buyers."
            htag="ad-writing-tips"
          />
        </Column>
        <Column>
          <Tool
            enabled={true}
            svg={CalculatorSvg}
            label="Price Guide"
            destination={Routes.PRICE_GUIDE}
            description="A valuation calculator that provides a suggested price range for your business, based on your financials and historical SEEK Business data."
            htag="price-guide"
          />
        </Column>
        <Column>
          <Tool
            enabled={true}
            svg={ScreeningSvg}
            label="Buyer Screening Guide"
            destination={queryString.stringifyUrl({
              url: Routes.ASSET,
              query: { key: Routes.BUYER_SCREENING_GUIDE },
            })}
            description="A comprehensive guide to assessing potential business buyers
            when they make enquiries on your ad."
            htag="buyer-screening-guide"
          />
        </Column>
        <Column>
          <Tool
            enabled={true}
            svg={ChecklistSvg}
            label="Business Sale Checklist"
            destination={queryString.stringifyUrl({
              url: Routes.ASSET,
              query: { key: Routes.BUSINESS_SALE_CHECKLIST },
            })}
            description="A checklist to help you confidently prepare for the final stages of selling and ensure you've covered all bases for closing the deal."
            htag="business-sale-checklist"
          />
        </Column>
      </Columns>
    </Card>
    <Card>
      <Box
        style={{
          position: 'relative',
          paddingBottom: '56.25%',
          paddingTop: '35px',
          height: '0',
          overflow: 'hidden',
        }}
      >
        <iframe
          src={adWritingGuideVideoLink}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: 'absolute',
            border: '0px',
            height: '100%',
            width: '100%',
            top: '0',
            left: '0',
          }}
        />
      </Box>
    </Card>

    <Card>
      <Stack space="gutter">
        <Divider />
        <Heading level="4">Useful Articles</Heading>
        <List>
          <BulletLink suffix="how-to-sell-a-business-the-ultimate-guide" />
          <BulletLink suffix="how-long-does-it-take-to-sell-a-business" />
          <BulletLink suffix="quick-ways-to-value-your-business" />
          <BulletLink suffix="who-should-you-trust-when-selling-a-business" />
          <BulletLink suffix="checklist-for-selling-a-business" />
        </List>
      </Stack>
    </Card>
  </Stack>
);

export default ToolsTab;
